import React from "react";
import { getJwt } from "../../../auth";
import { goTo } from "../../../utils/utils";
import TrackedButton from "../../Docuclipper/TrackedButton";
import quickbooksConnectIcon from "../../../icons/C2QB_green_btn_med_default.svg";

const INTEGRATIONS = {
  quickbooks: {
    scope: "intuit.quickbooks.accounting",
    url: `/api/v1/protected/auth/intuit`,
  },
};

export const goToQuickbooks = (next: string) =>
  goTo(`${INTEGRATIONS.quickbooks.url}?token=${getJwt()}${next}`);

const navigate = () => {
  const next = `&next=${encodeURIComponent(`/manageIntegrations`)}`;
  goToQuickbooks(next);
};

const QuickBooksAddNewCompany = () => (
  <>
    {/* <span className="mr-2">Add a new QuickBooks company:</span> */}
    <div className="m-4">
      <div className="h1">Add QuickBooks Company</div>
      {/* <div className="m-2">
        Click on "Connect to QuickBooks" to connect a new QuickBooks company to
        DocuClipper
      </div> */}
      <div
        // variant="primary"
        // action="connectToQuickbooks"
        className="btn--add-quickbooks"
        onClick={navigate}
        style={{ cursor: "pointer" }}
      >
        <img
          style={{ height: "36px" }}
          src={quickbooksConnectIcon}
          alt="QuickBooks logo"
        />

        {/* <CollapsibleBtnText icon="plus" text="Connect QuickBooks Company" /> */}
      </div>
    </div>
  </>
);
export default QuickBooksAddNewCompany;
